import apiHandler from '../core/apiHandler';

const restaurantReservationApi = apiHandler('restaurant/reservations');

export default restaurantReservationApi;

